import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ProcessService } from '../../../../services/process.service';
import { Process, ProcessReportSetting, 
   ProcessParticipationApprovalRequirementType } from '../../../../models/process-models';

@Component({
    selector: 'app-process-settings',
    templateUrl: './process-settings.component.html',
    styleUrls: ['./process-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProcessSettingsComponent implements OnInit {
    @Input() process: Process;
    isToggle = true;
    approvalType = ProcessParticipationApprovalRequirementType;
    constructor(private processService: ProcessService) {}

    ngOnInit() {
      if (!this.process.approvalRequirementTypes) { this.process.approvalRequirementTypes = []; }
    }

    toggleSetting(settingItem: number, settingArray: Array<number>) {
      this.processService.toggleEnumSetting(settingArray, settingItem);
    }

    getIsSet(settingItem: number, settingsArray: Array<number>) {
      return settingsArray.indexOf(settingItem) !== -1;
    }

    toggleProcessParticipationSkippable() {
        this.process.isProcessParticipationSkippable = !this.process.isProcessParticipationSkippable;
    }
  }